// extracted by mini-css-extract-plugin
export var actionText = "_oc-4";
export var container = "_oc-0";
export var leftSection = "_oc-1";
export var rightSection = "_oc-2";
export var settingsButton = "_oc-6";
export var settingsIcon = "_oc-7";
export var shortcut = "_oc-5";
export var shortcutGroup = "_oc-3";